import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/govAffairs',
    component: HeaderAsideLayout,
    children: [
      { path: '/govAffairs', component: () => import('@/pages/govAffairs/index.vue') },
    ],
  },
]
export default list